import { ispApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { ProductInfoResponse } from 'src/types';

export const getProductInfo = (config: AxiosRequestConfig = {}) =>
  ispApi.get<ProductInfoResponse>('/isp-internal/api/v1/productInfo', config);

export const updateProductDescription = (description: string) =>
  ispApi.patch<void>('/isp-internal/api/v1/productInfo', { description });
